'use strict';

var React = require('react');
var cs = require('classnames');
require('../../Box/Box.js');
require('../../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../../Icon/Icon.js');
require('../../../icons/AlertTriangleOutline.js');
require('../../../icons/BulbOutline.js');
require('../../../icons/CheckmarkOutline.js');
var icons_EyeOffOutline = require('../../../icons/EyeOffOutline.js');
var icons_EyeOutline = require('../../../icons/EyeOutline.js');
require('../../../icons/InfoOutline.js');
require('../../../icons/LoaderOutline.js');
require('../../Text/Text.js');
var formik = require('formik');
require('../../ExtraInfo/utils/returnIcon.js');
var components_ExtraInfo_ExtraInfo = require('../../ExtraInfo/ExtraInfo.js');
var components_Form_Label_Label = require('../Label/Label.js');
require('@sendsprint/api-types');
require('../../Flag/assets/Ca.js');
require('../../Flag/assets/Gb.js');
require('../../Flag/assets/Gh.js');
require('../../Flag/assets/Ke.js');
require('../../Flag/assets/Ng.js');
require('../../Flag/assets/Us.js');
require('../../Flag/assets/Za.js');
require('../../Flag/assets/None.js');
require('../../Flag/utils/getFlagSvgByCountryInitials.js');
require('../../Flag/Flag.js');
var components_Form_formDropdown_utils_handleIcon = require('../formDropdown/utils/handleIcon.js');
var components_Skeleton_Skeleton = require('../../Skeleton/Skeleton.js');
var uuid = require('uuid');
require('../../../FormInput-b542756e.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const FormInput = ({ name, placeholder, label, type = "text", className, icon, iconRight, inputRef, extraInfo, disabled, disableErrorFromShowing, isLoading, autoComplete, onBlur, onFocus, onBlurCapture, }) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [isLabelUp, setIsLabelUp] = React.useState(false);
    const [isInvalid, setIsInvalid] = React.useState(false);
    const [inputType, setInputType] = React.useState(type);
    const field = formik.useField(name);
    const fieldValue = field[0].value;
    const fieldError = field[1].error;
    const isFieldTouched = field[1].touched;
    const fieldBlurFunction = field[0].onBlur;
    const id = uuid.v4();
    React.useEffect(() => {
        if (isFocused ||
            fieldValue ||
            type === "date" ||
            type === "datetime-local" ||
            (type === "number" && fieldValue === 0)) {
            setIsLabelUp(true);
        }
        else {
            setIsLabelUp(false);
        }
    }, [isFocused, fieldValue, type]);
    React.useEffect(() => {
        if (fieldError && isFieldTouched) {
            setIsInvalid(true);
        }
        else {
            setIsInvalid(false);
        }
    }, [fieldError, isFieldTouched]);
    const handlePasswordShow = () => {
        if (inputType === "password") {
            setInputType("text");
        }
        else {
            setInputType("password");
        }
    };
    const classes = cs__default['default']("", {
        [`${className}`]: className,
    });
    if (isLoading) {
        return React__default['default'].createElement(components_Skeleton_Skeleton, { className: "ss-h-14 ss-w-full ss-rounded-base" });
    }
    return (React__default['default'].createElement("div", { className: classes },
        React__default['default'].createElement("div", { className: "ss-relative ss-w-full" },
            label && (React__default['default'].createElement(components_Form_Label_Label, { className: cs__default['default']("ss-absolute   ss-duration-150 ss-transform", {
                    "ss-text-paragraph-very-small ss-top-1": isLabelUp || fieldValue,
                    "text-text-sm ss-top-4": !isLabelUp,
                    " ss-border-error-500": isInvalid,
                    "text-error-400": isInvalid && isLabelUp,
                    "ss-left-14": icon,
                    "ss-left-4": !icon,
                    "ss-text-neutral-300": disabled,
                    "ss-text-neutral-400": !disabled,
                }), htmlFor: id }, label)),
            React__default['default'].createElement(formik.Field, { name: name, id: id, type: inputType, disabled: disabled, autoComplete: type === "password" ? "off" : autoComplete, className: cs__default['default']("ss-border ss-text-paragraph-regular ss-px-4 ss-rounded-base ss-block ss-w-full focus:ss-focus-ring ss-bg-neutral-100 ss-placeholder-neutral-400 ss-text-neutral-500 ss-border-neutral-300 hover:ss-border-primary1-500 focus:ss-border-primary1-50", {
                    "focus:shadow-focused-re ss-border-error-500 focus:border-error-hover": fieldError && isFieldTouched && fieldValue,
                    "focus:shadow-focused-red ss-border-error-500 focus:border-error-hover": fieldError && isFieldTouched && !fieldValue,
                    "border-purple-main": fieldValue && !fieldError,
                    "border-gray-border": !fieldValue && !fieldError,
                    "ss-pt-6 ss-pb-2": isLabelUp,
                    "ss-pt-4 ss-pb-4": !isLabelUp,
                    "ss-pr-10": iconRight,
                    "ss-pl-14": icon,
                    "ss-bg-neutral-100 ss-text-neutral-300 ss-border-neutral-200 ss-cursor-not-allowed": disabled,
                    "ss-border-error-500": isInvalid,
                }), placeholder: placeholder, innerRef: inputRef, onFocus: (e) => {
                    setIsFocused(true);
                    onFocus?.(e);
                }, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onBlur: (e) => {
                    setIsFocused(false);
                    fieldBlurFunction(e);
                    onBlur?.(e);
                }, onBlurCapture: onBlurCapture }),
            type === "password" && (React__default['default'].createElement("button", { type: "button", onClick: handlePasswordShow, className: "ss-absolute ss-top-2/4 ss-right-3 ss-transform ss--translate-y-2/4" },
                inputType === "password" && (React__default['default'].createElement(components_Icon_Icon, { className: cs__default['default']("ss-w-5 ss-h-5", {
                        "ss-text-neutral-500": isLabelUp,
                        "ss-text-neutral-300": !isLabelUp,
                    }), svg: icons_EyeOffOutline, size: "100%" })),
                inputType === "text" && (React__default['default'].createElement(components_Icon_Icon, { className: cs__default['default']("ss-w-5 ss-h-5", {
                        "ss-text-neutral-500": isLabelUp,
                        "ss-text-neutral-300": !isLabelUp,
                    }), svg: icons_EyeOutline, size: "100%" })))),
            iconRight &&
                components_Form_formDropdown_utils_handleIcon.handleIcon({
                    icon: iconRight,
                    className: cs__default['default']("ss-absolute ss-w-5 ss-h-5 ss-top-2/4 ss-right-3 ss-transform ss--translate-y-2/4", {
                        "ss-text-neutral-500": isLabelUp,
                        "ss-text-neutral-300": !isLabelUp,
                    }),
                    size: "100%",
                })
        // <Icon
        //   className={cs(
        //     "ss-absolute ss-w-5 ss-h-5 ss-top-2/4 ss-right-3 ss-transform ss--translate-y-2/4",
        //     {
        //       "ss-text-neutral-500": isLabelUp,
        //       "ss-text-neutral-300": !isLabelUp,
        //     }
        //   )}
        //   svg={iconRight}
        //   size="100%"
        // />
        ,
            icon &&
                components_Form_formDropdown_utils_handleIcon.handleIcon({
                    icon,
                    className: cs__default['default']("ss-absolute ss-w-6 ss-h-6 ss-top-2/4 ss-left-4 ss-transform ss--translate-y-2/4", {
                        "ss-text-neutral-500": isLabelUp,
                        "ss-text-neutral-300": !isLabelUp,
                    }),
                    size: "100%",
                })
        // <Icon
        //   className={cs(
        //     "ss-absolute ss-w-6 ss-h-6 ss-top-2/4 ss-left-4 ss-transform ss--translate-y-2/4",
        //     {
        //       "ss-text-neutral-500": isLabelUp,
        //       "ss-text-neutral-300": !isLabelUp,
        //     }
        //   )}
        //   svg={icon}
        //   size="100%"
        // />
        ),
        !disableErrorFromShowing && (React__default['default'].createElement(formik.ErrorMessage, { name: name }, (errMessage) => React__default['default'].createElement(components_ExtraInfo_ExtraInfo, { variant: "error", extraInfo: errMessage }))),
        extraInfo && React__default['default'].createElement(components_ExtraInfo_ExtraInfo, { extraInfo: extraInfo })));
};

module.exports = FormInput;
